import { render, staticRenderFns } from "./DimissionExamine.vue?vue&type=template&id=0648ebf0&scoped=true&"
import script from "./DimissionExamine.vue?vue&type=script&lang=js&"
export * from "./DimissionExamine.vue?vue&type=script&lang=js&"
import style0 from "./DimissionExamine.vue?vue&type=style&index=0&id=0648ebf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648ebf0",
  null
  
)

export default component.exports